import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import fontStyles from 'Styles/fonts.scss';
import {
  colourMaster,
  colourMasterDarker,
  colourMasterLighter,
  colourPrimary,
  colourDanger,
  colourWhite,
  colourMasterLightest,
  colourDangerLight,
  colourPrimaryLighter,
} from 'Styles/colors.css';

const DefaultButton = styled.button`
  padding: 5px 16px;
  margin-bottom: 0;
  border: 1px solid ${colourMasterLighter};
  user-select: none;
  cursor: pointer;
  border-radius: 3px;
  color: ${colourMaster};
  background-color: ${colourWhite};
  position: relative;
  transition: color 0.1s linear 0s, background-color 0.1s linear 0s, opacity 0.2s linear 0s;

  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  opacity:  ${props => (props.disabled ? 0.65 : 1)};

  &:hover {
    color: ${colourMasterDarker};
    text-decoration: none;
    background-color: ${colourMasterLightest};
    border-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.07);
  }
`;

const DangerButton = styled(DefaultButton)`
  color: ${colourWhite};
  background-color: ${colourDanger};
  border-color: ${colourDanger};

  &:hover {
    color: ${colourWhite};
    background-color: ${colourDangerLight};
    border-color: ${colourDangerLight};
  }
`;

const PrimaryButton = styled(DefaultButton)`
    color: ${colourWhite};
    background-color: ${colourPrimary};
    border-color: ${colourPrimary};

    &:hover {
      color: ${colourWhite};
      background-color: ${colourPrimaryLighter};
      border-color: ${colourPrimaryLighter};
    }
`;

const buttons = {
  default: DefaultButton,
  danger: DangerButton,
  primary: PrimaryButton,
};

// eslint-disable-next-line react/prefer-stateless-function
class WveInputButton extends PureComponent {
  render() {
    const {
      onClick,
      children,
      classes,
      className,
      tooltipTitle,
      disabled,
      appearance,
    } = this.props;

    const Button = buttons[appearance];

    return (
      <Button
        type="button"
        className={`${fontStyles.button} ${classes} ${className}`}
        onClick={onClick}
        data-original-title={tooltipTitle}
        appearance={appearance}
        disabled={disabled}
      >
        {children}
      </Button>
    );
  }
}

WveInputButton.defaultProps = {
  onClick: () => {},
  children: null,
  classes: '',
  className: '',
  tooltipTitle: '',
  disabled: false,
  appearance: 'default',
};

WveInputButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  classes: PropTypes.string,
  className: PropTypes.string,
  tooltipTitle: PropTypes.string,
  disabled: PropTypes.bool,
  appearance: PropTypes.string,
};

export default WveInputButton;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputButton/WveInputButton.jsx